var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.81 19.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,7.56a2,2,0,0,1-.57-1.73A2.86,2.86,0,0,0,16.09,2.6a2.07,2.07,0,0,1-1.48-1.07A2.84,2.84,0,0,0,10.82.3,2.17,2.17,0,0,1,9,.3,2.84,2.84,0,0,0,5.2,1.53,2.07,2.07,0,0,1,3.72,2.6,2.86,2.86,0,0,0,1.38,5.83,2,2,0,0,1,.81,7.56a2.87,2.87,0,0,0,0,4,2,2,0,0,1,.57,1.73,2.86,2.86,0,0,0,2.34,3.23A2.07,2.07,0,0,1,5.2,17.59,2.84,2.84,0,0,0,9,18.82a2.17,2.17,0,0,1,1.83,0,2.84,2.84,0,0,0,3.79-1.23,2.07,2.07,0,0,1,1.48-1.07,2.86,2.86,0,0,0,2.34-3.23A2,2,0,0,1,19,11.56,2.87,2.87,0,0,0,19,7.56ZM17.64,13.4A2.06,2.06,0,0,1,16,15.73a2.87,2.87,0,0,0-2,1.49,2.07,2.07,0,0,1-2.74.89,2.82,2.82,0,0,0-2.53,0,2.07,2.07,0,0,1-2.74-.89,2.87,2.87,0,0,0-2-1.49A2.06,2.06,0,0,1,2.17,13.4,2.87,2.87,0,0,0,1.39,11a2.06,2.06,0,0,1,0-2.88,2.87,2.87,0,0,0,.78-2.4A2.06,2.06,0,0,1,3.86,3.39a2.87,2.87,0,0,0,2-1.49A2.07,2.07,0,0,1,8.64,1a2.82,2.82,0,0,0,2.53,0,2.07,2.07,0,0,1,2.74.89,2.87,2.87,0,0,0,2,1.49,2.06,2.06,0,0,1,1.69,2.33,2.87,2.87,0,0,0,.78,2.4,2.06,2.06,0,0,1,0,2.88A2.87,2.87,0,0,0,17.64,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.15,9.29a1.8,1.8,0,0,0-1.82,2,1.81,1.81,0,0,0,1.95,1.84,1.8,1.8,0,0,0,1.82-2A1.79,1.79,0,0,0,12.15,9.29Zm.1,2.93a.93.93,0,0,1-.95-1,.93.93,0,1,1,1.84-.06A.92.92,0,0,1,12.25,12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48,7.27A1.82,1.82,0,0,0,7.53,5.42a1.82,1.82,0,0,0-1.82,2,1.83,1.83,0,0,0,2,1.85A1.82,1.82,0,0,0,9.48,7.27Zm-2.8.08a.92.92,0,0,1,.88-1.08c.59,0,.94.4,1,1a.93.93,0,1,1-1.84.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.81,5.16c-1.48,2.61-3,5.22-4.47,7.82l.67.36,4.46-7.81Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.3f5c6d5065b5d3a11fe3b9ac1f6da584.svg";
export { ForwardRef as ReactComponent };